import React from 'react';
import { graphql, compose } from 'react-apollo';
import { offerCommentsQuery, submitCommentMutation } from '../../../apollo';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { withAlertHandler } from 'entoro-shared';
import { Field, reduxForm, reset } from 'redux-form';
import Button from 'material-ui/Button';
import CommentSection from './CommentSection';
import TextFieldArea from '../../FormFields/TextField';

const Comment = reduxForm({
  form: 'commentForm',
})(
  ({
    setSnackbarMessage,
    disabled,
    handleSubmit,
    submitting,
    handleSnackbarError,
    client,
    investorUser,
    offer,
    data: { offerComments },
  }) => {
    const submitComments = async (values, dispatch) => {
      const { mutate } = client;
      const refetchQueries = [
        {
          query: offerCommentsQuery,
          variables: {
            offerId: offer._id,
          },
        },
      ];

      try {
        const variables = {
          input: {
            ...values,
            offerId: offer._id,
          },
        };
        const { data } = await mutate({
          mutation: submitCommentMutation,
          variables,
          refetchQueries,
        });

        if (data.submitComment) {
          dispatch(reset('commentForm'));
          //comment added
          setSnackbarMessage('comment added successfully');
        }
      } catch (error) {
        handleSnackbarError(error);
      }
    };

    return (
      <div>
        <h3> Leave a Message </h3>
        <div className='add-comment-box'>
          <div className='add-comment-form'>
            <form id='add-comment-form' onSubmit={handleSubmit(submitComments)}>
              <div className='w-row'>
                <div className='column-2 w-col w-col-8'>
                  <Field
                    required
                    component={TextFieldArea}
                    name='content'
                    label='Enter your Message'
                    multiline
                    autoFocus
                  />
                </div>
              </div>
              <div className='button-box'>
                <Button
                  type='submit'
                  disabled={disabled || submitting}
                  className='action-button'
                  disableRipple
                  style={{ width: 0 }}
                >
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
        <CommentSection
          comments={offerComments}
          offer={offer}
          investorUser={investorUser}
        />
      </div>
    );
  }
);

const WithDataHOC = (ComponentToWrap) => (props) => {
  const { offer } = props;
  const WithData = compose(
    graphql(offerCommentsQuery, {
      options: ({ match }) => ({
        variables: {
          offerId: offer._id,
        },
      }),
    })
  )(ComponentToWrap);

  return <WithData {...props} />;
};
const mapStateToProps = (state) => {
  const { investorUser = {} } = state;
  const { adminCommentModerator } = investorUser;
  //const selector = formValueSelector('commentForm');

  return {
    // requireAddressDetail: selector(state, 'country') === 'US',
    initialValues: {
      ...investorUser,
      adminCommentModerator: adminCommentModerator || '',
    },
  };
};
export default connect()(withApollo(withAlertHandler(WithDataHOC(Comment))));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/Comments/index.js